<div ngbDropdown display="dynamic" (openChange)="open.emit($event)">
  <div ngbDropdownToggle class="no-caret">
    <button
      class="btn w-100"
      placement="right"
      [ngbTooltip]="isCollapsed() ? title() : ''"
      [ngClass]="isCollapsed() ? 'btn-link' : 'btn-outline'"
    >
      @if (avatar() !== undefined && avatar() !== null) {
        <cds-avatar [text]="avatar() ?? ''" />
      }
      @if (!isCollapsed()) {
        <div class="text-start org-info flex-grow-1 overflow-hidden">
          <div class="text-dark fw-bold text-truncate">
            {{ title() }}
          </div>
          <div class="fs-5 text-muted text-truncate">
            {{ subTitle() }}
          </div>
        </div>
        <cds-icon shape="ArrowsCaretDown" />
      }
    </button>
  </div>
  <div ngbDropdownMenu class="shadow-lg p-0 overflow-hidden above-sticky">
    <ng-content select="[header]"></ng-content>
    <div
      class="overflow-y-auto overflow-x-hidden"
      [style.min-width]="minWidth()"
      [style.max-width]="maxWidth()"
      [style.min-height]="minHeight()"
      [style.max-height]="maxHeight()"
    >
      @for (item of items(); track $index) {
        <div class="dropdown-item pointer" (click)="select.emit(item)">
          <ng-container
            *ngTemplateOutlet="itemTemplate(); context: { $implicit: item, index: $index }"
          ></ng-container>
        </div>
      } @empty {
        <div class="dropdown-item-text">
          {{ empty() }}
        </div>
      }
    </div>
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
